import React from 'react'
import { Link } from 'react-router-dom'; 
import { useState } from 'react';
import "./nepaltour.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footernav from "./Component/footernav"
import { faArrowDown, faArrowUp, faChevronDown, faChevronUp,faStar,faLocationDot} from "@fortawesome/free-solid-svg-icons";
const NepalPackage = () => {
        const [isOpen, setIsOpen] = useState(false);
        const toggleSort = () => {
          setIsOpen(!isOpen);
        };
      
        const handleLongTour = () => {
            const window=0;
          if(window<window.innerHeight){
          const scrollAmount = window.innerHeight * 0.5;
          window.scrollBy({
            top: scrollAmount,
            behavior: "smooth",
          });}}
  return (
   <main>
    <section className="body">
    <div className="tourSortMobile">
     <div className="filtering">
       <div className="location">
        <p className='sortItem'>Our Location</p>
        <iframe className="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3531.006345162988!2d85.29679076845517!3d27.74795029415453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb194918041995%3A0x2290f0e48f50d549!2sUjalo%20Basthi%20Lolang%20height!5e0!3m2!1sne!2snp!4v1736396520103!5m2!1sne!2snp" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
       </div>
       <div className="popular-filter">
        <p className='sortItem'>Popular Filter</p>
        <div className="popular-sort">
            <div className="legend">
                <div id="tick"></div>
                <h5>One Day Nepal Tour</h5>
            </div>
            <div className="legend">
                <div id="tick"></div>
                <h5>Short Day Nepal Tour</h5>
            </div>
            <div className="legend">
                <div id="tick"></div>
                <h5>Medium Day Nepal Tour</h5>
            </div>
            <div className="legend"onClick={()=>handleLongTour()}>
                <div id="tick"></div>
                <h5>Long Day Nepal Tour</h5>
            </div>
        </div>
       </div>
     </div>
      {/* Sort Button */}
     

    </div>
     <div className="body-card">
        <h3>Nepal One Day Tour:</h3>
        <div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/mounteve/Heli.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Everest Heli Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu, Lukla</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $1300
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
       Duration: 4 Hours
    </p>

    <Link to="/Everest-Heli-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/capital/swyambhunath1dslr.jpeg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      The Big Four
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Pasupatinath +3 Places</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $140
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
     Duration: 1 Days
    </p>

    <Link to="/One-Day-Kathmandu-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/capital/pasupatinath.jpg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      7 Unesco Heritage Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Bouddha + 6 Places</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $190
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
      Duration: 1 Day
    </p>

    <Link to="/one-day-nepal-7unescoheritage-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/mounteve/moun2.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
     Mountain Flight Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Mt Everest, Mt Lhotse + 2 </span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $280
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
      Duration: 1 Hour
    </p>

    <Link to="/mountain-flight-nepal-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<h3>Nepal Short Day Tour:</h3>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/pokhara/pokhara3dslr.jpeg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
    Nepal's Heritage & Horizon Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>kathmandu + 2 City</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $890
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration: 5N/6D
    </p>

    <Link to="/kathmandu-pokhara-6days-tours"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>

<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/capital/nagarkot.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
    The Quick & Classic
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu and Nagarkot</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $400
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration: 3N/4D
    </p>

    <Link to="/kathmandu-nagarkot-4days-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/chitwan/chitwan4dslr.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
    Peak & Safaris
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Chitwan +2 Cities</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $1150
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration: 5N/6D
    </p>

    <Link to="/kathmandu-chitwan-nagarkot"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/chitwan/Chitwan.jpg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
     Wilderness & wisdom
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Lumbini +2 Cities</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $1150
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration:5N/6D
    </p>

    <Link to="/kathmandu-chitwan-lumbini"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/mounteve/mountain.jpg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
    Everest For Senior
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Everest Without Treeking</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $5850
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration: 5N/6D
    </p>

    <Link to="/everest-for-senior-withouttrek"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<h3>Nepal Medium Day Tour:</h3>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/capital/meditation.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
   Himalayan Healing
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Mental Retreat Activities</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      Starting From $2220
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration: 6N/7D
    </p>

    <Link to="/nepal-wellness-retreat-7days-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
        <div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/chitwan/chitwandslr.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
    Nepal’s Golden Triangle
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu +2 Cities</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
        Starting Price $940
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
       Duration : 7N/8D
    </p>

    <Link to="/kathmandu-chitwan-pokhara-8days-nepaltour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/pokhara/bandipurdslr.jpeg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      The Classic Circuits
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Bandipur + 4 Cities</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      Starting From $1600
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration : 9N/8D
    </p>

    <Link to="/kathmandu-chitwan-pokhara-bandipur-nagarkot-9days-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/chitwan/lumbini.jpg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
     Nepal Essential Four
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Pokhara + 3 Cities</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      Starting From $1100
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration : 8N/7D
    </p>

    <Link to="/kathmandu-chitwan-lumbini-pokhara-8days-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/chitwan/chitwan8dslr.jpeg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
    City Jungle Mountain
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu + 4 Cities</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
       Starting From $1600
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration : 7N/8D
    </p>

    <Link to="/kathmandu-chitwan-pokhara-nagarkot-8days-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<h3>Nepal Long Day Tour:</h3>
       
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/treek/Dhampus.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
     Nature's Majestic Loop
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Ghandrukh + 7 Cities</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      Starting From $2350
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration : 9N/8D
    </p>

    <Link to="/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/company/airportdslr.jpeg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      All nepal Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Popular Places Of Nepal</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $4200
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration : 14N/15D
    </p>

    <Link to="/all-nepal-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/capital/namobuddha.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Buddhism Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Different Bhuddhist Places</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $3600
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration : 12N/13D
    </p>

    <Link to="/buddhism-tour-nepal"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/capital/capital1dslr.jpeg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Peaks Parks Peace
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Nagarkot + 5 Places</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
     Starting From $2400
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
    Duration : 9N/10D
    </p>

    <Link to="/kathmandu-chitwan-pokhara-lumbini-bandipur-nagarkot-11days-tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
     </div>
     
    </section>
    <Footernav/>
   </main>
  )}
export default NepalPackage